class TimetableSlot {
    timeIn: string;
    timeOut: string;
    dayOfWeek: string;
    isEmptySlot: boolean;

    constructor(timeIn: string, timeOut: string, dayOfWeek: string) {
        this.timeIn = timeIn;
        this.timeOut = timeOut;
        this.dayOfWeek = dayOfWeek;
        this.isEmptySlot = true;
    }
}

export default TimetableSlot;
